























import { computed, defineComponent, onMounted, watch } from '@vue/composition-api';
import type { PropType } from 'vue';
import type { SigningTheme } from '@getaccept/lib-shared/src/signing-theme/types/theme';
import { BrandingHelper } from '@getaccept/lib-shared/src/signing-theme/helpers/branding.helper';
import TopBar from '../../signing/components/TopBar.vue';
import LobbyCard from '../../lobby/components/LobbyCard.vue';
import DsrUnavailable from '../../lobby/components/DsrUnavailable.vue';
import IdentifyRecipientModal from './IdentifyRecipientModal.vue';
import IdentifyRecipientDsrModal from './IdentifyRecipientDsrModal.vue';

import { useUniversalLink } from './composables/universal-link.composable';

export default defineComponent({
  name: 'UniversalLinkLobby',
  components: {
    TopBar,
    LobbyCard,
    IdentifyRecipientModal,
    IdentifyRecipientDsrModal,
    DsrUnavailable,
  },
  props: {
    universalId: {
      type: String,
      required: true,
    },
    theme: {
      type: Object as PropType<SigningTheme>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const {
      loading,
      faildToVerify,
      verifyLinkResponse,
      verifyLink,
      failedRestricted,
    } = useUniversalLink();

    onMounted(() => {
      verifyLink(props.universalId);
    });

    const documentLogo = computed(() => BrandingHelper.getLogoUrl(props.theme));

    const documentId = computed(() => verifyLinkResponse.value?.documentId);

    const isDsr = computed(() => verifyLinkResponse.value?.documentType === 'dsr');

    watch(documentId, () => {
      if (documentId.value) {
        emit('documentLoaded', documentId.value);
      }
    });

    return {
      loading,
      faildToVerify,
      verifyLinkResponse,
      documentLogo,
      documentId,
      isDsr,
      failedRestricted,
    };
  },
});
